import { NgModule } from '@angular/core';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { SolutionsManagerComponent } from './solutions-manager.component';
import { MaterialModule } from 'src/app/material/material.module';
import { RouterModule } from '@angular/router';
import { TextPrettyPipe } from 'src/app/pipes/text-pretty.pipe';
import { ShowDialogsComponent } from 'src/app/components/show-dialogs/show-dialogs.component';
import { NamingSizePipe } from 'src/app/pipes/naming-size.pipe';
import { SolutionsManagerRoutingModule } from './solutions-manager-routing.module';
import { MarketplaceManagerComponent } from './components/marketplace-manager/marketplace-manager.component';
import { GenSubscriptionKeyComponent } from './components/gen-subscription-key/gen-subscription-key.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { ViewSubscriptionKeyComponent } from './components/view-subscription-key/view-subscription-key.component';
import { TenantWebchatConfigurationComponent } from './components/tenant-webchat-configuration/tenant-webchat-configuration.component';
import { ManageWebchatComponent } from './components/manage-webchat/manage-webchat.component';
import { TenantHomepageConfigurationComponent } from './components/tenant-homepage-configuration/tenant-homepage-configuration.component';
import { ManageCustomerHomepageComponent } from './components/manage-customer-homepage/manage-customer-homepage.component';

@NgModule({
  declarations: [SolutionsManagerComponent, MarketplaceManagerComponent, GenSubscriptionKeyComponent, ViewSubscriptionKeyComponent, TenantWebchatConfigurationComponent, ManageWebchatComponent, TenantHomepageConfigurationComponent, ManageCustomerHomepageComponent],
  imports: [
    CommonModule,
    MaterialModule,
    RouterModule,
    TextPrettyPipe,
    TitleCasePipe,
    ShowDialogsComponent,
    NamingSizePipe,
    SolutionsManagerRoutingModule,
    ReactiveFormsModule,
    ClipboardModule
  ],
})
export class SolutionsManagerModule {}
